import React, { FC, memo, useEffect } from 'react';
import LoginPageLayout from '../components/loginSignup/LoginPageLayout';
import PatientRoomCodeBox from '../components/loginSignup/PatientRoomCodeBox';
import { LoginBoxAuth0 } from '../components/loginSignup/LoginBoxAuth0';
import { useExtendedAuth } from '../util/auth0';
import { useNavigate } from 'react-router';
import { useAuth0 } from "@auth0/auth0-react";
import { emitNotification } from "../components/Notification";
import i18next from "i18next";

const LoginPageContainer: FC<{signIn:boolean}> = ({signIn}) => {
  const { isAuthenticated, logout, user } = useAuth0();
  const { isApprovedTherapist } = useExtendedAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const checkIsApproved = async (): Promise<void> => {
      try {
        const isApproved = await isApprovedTherapist();
        if (isApproved) {
          navigate('/therapien');
        } else {
          navigate('/account-setup');
        }
      }
      catch {
        emitNotification(i18next.t('errorMessageTemplate.genericMsg'), {
          type: 'error',
          position: 'top-right'
        });
        await logout();
      }
    }

    if (isAuthenticated && user && user.email_verified) {
      checkIsApproved();
    }
  }, [isAuthenticated]);

  return <LoginPageLayout patientRoomLoginComponent={<PatientRoomCodeBox />} loginComponent={<LoginBoxAuth0 login={signIn} />} signIn={signIn} />;
};

export default memo(LoginPageContainer);
